module.exports = __webpack_public_path__ + "static/pepe_galindo-3899e9c35512adfcf886cbc64acdfcb9.jpg";